import { render, staticRenderFns } from "./privacyPolicyReview.vue?vue&type=template&id=456ef0ae&scoped=true"
import script from "./privacyPolicyReview.vue?vue&type=script&lang=js"
export * from "./privacyPolicyReview.vue?vue&type=script&lang=js"
import style0 from "./privacyPolicyReview.vue?vue&type=style&index=0&id=456ef0ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456ef0ae",
  null
  
)

export default component.exports